import * as api from '@/lti/api'
import { storeAllEntities } from '@/lti/store/helpers'

export default {
  state: {
    programs: {},
    terms: {},
  },

  actions: {
    getPrograms ({ commit }, { withTerms }) {
      const includes = withTerms ? ['terms'] : []

      return api.getPrograms({ include: includes })
        .then(storeAllEntities(commit))
    },
  },

  getters: {},
}
